import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import {withFirebase} from '../Firebase';
import {AuthUserContext, withAuthorization} from '../Session';
import {CustomDateReport} from './CustomDateReport';
import 'react-tabs/style/react-tabs.css';

const ReportsPage = ({fakeUid}) => (
    <AuthUserContext.Consumer>
        {authUser => (
            <div className="min-h-screen bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
                        <p className="text-gray-600 mt-1">Account: {authUser.email}</p>
                    </div>
                    <ReportsContent authUser={authUser} fakeUid={fakeUid}/>
                </div>
            </div>
        )}
    </AuthUserContext.Consumer>
);

let useUID;

class ReportsContentBase extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.fakeUid) {
            useUID = this.props.fakeUid;
        } else {
            useUID = this.props.authUser.uid;
        }
        this.state = {
            loading: false,
            files: [],
        };
        this.fetchAllPublicFiles = this.fetchAllPublicFiles.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true});
        this.fetchAllPublicFiles();
    }

    fetchAllPublicFiles() {
        const fileNames = [];
        const allFiles = this.props.firebase.publicStorageReference('/' + useUID);
        allFiles.listAll().then((result) => {
            this.setState({
                loading: false
            });
            const premisesUrl = [];
            const premisesMetadata = [];
            result.items.forEach((imageRef) => {
                fileNames.push(imageRef.name);
                premisesUrl.push(imageRef.getDownloadURL());
                premisesMetadata.push(imageRef.getMetadata());
            });
            return Promise.all(premisesUrl.concat(premisesMetadata));
        }).then(values => {
            const files = [];
            const urls = values.slice(0, fileNames.length);
            const metadata = values.slice(fileNames.length, values.length);
            urls.forEach((url, index) => {
                files.push({
                    name: fileNames[index],
                    fileUrl: url,
                    date: new Date(metadata[index].updated).toLocaleDateString(),
                    time: new Date(metadata[index].updated).toLocaleTimeString()
                });
            });
            this.setState({
                files: files
            });
        }).catch(function (error) {
            console.error("Can't fetch public files", error);
        });
    }

    render() {
        const {files, loading} = this.state;
        const companyId = useUID;

        // Check if Gold Gondola for showing Custom Report tab
        const isGoldGondola = companyId === 'jLDiu0jZ8nVdWUi2sslOqB9dDrL2';

        return (
            <Tabs>
                <TabList>
                    <Tab>Fajlovi</Tab>
                    {isGoldGondola && <Tab>Izveštaj po datumu</Tab>}
                </TabList>

                <TabPanel>
                    <div className="bg-white p-4 rounded-lg shadow border mt-4">
                        <h3 className="text-lg font-semibold mb-4">Dostupni fajlovi ({files.length})</h3>
                        {loading && <div>Loading ...</div>}
                        {files.length === 0 && !loading && (
                            <p className="text-gray-500">Nema dostupnih fajlova.</p>
                        )}
                        <div className="space-y-2">
                            {files.map((file, index) => (
                                <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded hover:bg-gray-100">
                                    <a
                                        href={file.fileUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:underline font-medium"
                                    >
                                        {file.name}
                                    </a>
                                    <span className="text-sm text-gray-500">
                                        {file.date}, {file.time}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </TabPanel>

                {isGoldGondola && (
                    <TabPanel>
                        <div className="mt-4">
                            <CustomDateReport companyId={companyId}/>
                        </div>
                    </TabPanel>
                )}
            </Tabs>
        );
    }
}

const ReportsContent = withFirebase(ReportsContentBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(ReportsPage);
